import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.agents')
  .filter('agentAcronyms', agentAcronyms);

function agentAcronyms() {
  return function (agent) {
    if (!_.get(agent, 'user')){
      return;
    }
    const user = agent.user;
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    return firstName[0] + '.' + lastName[0];
  }
}
